export enum ApiErrorType {
  NO_CONTENT = 204,
  CONFLICT = 409,
  UNKNOWN_ERROR = -1,
}

export class ApiResponseError extends Error {
  public readonly type: ApiErrorType;
  details?: any;

  constructor(type: ApiErrorType, message: string, details?: any) {
    super(message);
    this.type = type;
    this.details = details;
  }
}
